/**
 * v-permission 디렉티브
 *
 * 사용법:
 * <button v-permission="'/users/managers'">관리자 관리</button>
 * <div v-permission="'/system/security'">시스템 보안 설정</div>
 *
 * 권한이 없으면 해당 요소가 DOM에서 제거됩니다.
 */

export default {
  mounted(el, binding, vnode) {
    const { value } = binding;
    const store = vnode.appContext.config.globalProperties.$store;

    if (!value) {
      console.warn('[v-permission] 권한 경로가 지정되지 않았습니다.');
      return;
    }

    // super_admin은 모든 요소 표시
    const isSuperAdmin = store.getters['auth/isSuperAdmin'];
    if (isSuperAdmin) {
      return;
    }

    // 권한 체크
    const hasPermission = store.getters['auth/hasPermission'](value);

    if (!hasPermission) {
      // 권한이 없으면 요소 제거
      el.parentNode && el.parentNode.removeChild(el);
    }
  },

  updated(el, binding, vnode) {
    // 권한이 동적으로 변경될 수 있으므로 updated 훅에서도 체크
    const { value } = binding;
    const store = vnode.appContext.config.globalProperties.$store;

    if (!value) return;

    const isSuperAdmin = store.getters['auth/isSuperAdmin'];
    if (isSuperAdmin) {
      return;
    }

    const hasPermission = store.getters['auth/hasPermission'](value);

    if (!hasPermission && el.parentNode) {
      el.parentNode.removeChild(el);
    }
  }
};
